"use client";

import React, { useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourBreedingLegacyElevated() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5;
    }
  }, []);
  return <section id="your-breeding-legacy-elevated" className="dark bg-background text-foreground relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full bg-black">
        <video ref={videoRef} autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover opacity-60" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1453987/img/westminster_kennel_club_group_ring.png">
          <source src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1453987/img/westminster_kennel_club_group_ring.png" />
        </video>
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/20 to-black/60" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 flex flex-col items-center text-center gap-8 px-4 max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold text-white drop-shadow-[0_4px_8px_rgba(0,0,0,0.8)] leading-tight">Websites for responsible dog breeders</h1>
        
        <p className="font-sans text-lg md:text-2xl text-white/95 max-w-3xl drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)] tracking-wide font-light">Pupzstudio builds professional breeder websites that showcase your dogs, explain your process, and help you attract the right puppy inquiries.</p>
        
        <div className="flex flex-col sm:flex-row gap-6 mt-8">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg px-10 py-7 rounded-full shadow-[0_0_20px_rgba(212,175,55,0.2)] transition-all hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] hover:-translate-y-1">
            <Link to="/book-a-consultation">Book a Consultation</Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="border-2 border-primary text-primary hover:bg-primary/10 bg-black/20 backdrop-blur-sm text-lg px-10 py-7 rounded-full transition-all hover:-translate-y-1">
            <Link to="/Pricing">See Packages</Link>
          </Button>
        </div>
      </div>
    </section>;
}